import { Controller } from "@hotwired/stimulus"

// A transient notice: slides in, waits, fades out, removes itself.
//
// It has to remove itself because nothing else will. A toast arrives either streamed in by a state
// action or rendered by a redirect, and Turbo-Frame navigation never reloads <body> — one left
// behind would sit in the corner for the rest of the session, over the sidebar and, worse, still
// offering an Undo for a write from ten minutes ago.
const REMOVAL_FALLBACK = 500

export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    // On the next frame rather than now: a class set in the same frame as the insert has no
    // previous state to transition from, so the toast would appear rather than arrive.
    this.entrance = requestAnimationFrame(() => this.element.classList.add("toast--shown"))
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    cancelAnimationFrame(this.entrance)
    clearTimeout(this.timeout)
    clearTimeout(this.removal)
  }

  // Also the answer to pressing Undo (submit->toast#dismiss): the write this toast is about has
  // just been reversed, and its own response appends a toast saying so.
  dismiss() {
    this.element.classList.add("toast--dismissing")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
    // A transition that never fires would otherwise leave the toast on screen for good: reduced
    // motion drops it, and so does a background tab.
    this.removal = setTimeout(() => this.element.remove(), REMOVAL_FALLBACK)
  }
}
